export default __webpack_public_path__ + "static/media/Rectangle8623photo.402a93d2.png";